import { Card, CardContent } from '@/components/Card/Card';
import { ApiKeyStatus } from '@/bundle/_MasterAdmin/_DevelopersPage/ui/ApiKeyStatus/ApiKeyStatus';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { PopoverMenuActions } from '@/bundle/_MasterAdmin/_DevelopersPage/ui/EditPopoverMenu/PopoverMenuActions';
import { ApiKeyType } from '@/types/sharedTypes';
import { API_KEY_STATUS_TYPE } from '@/const/shared';
import { Box } from '@/components/Box/Box';

type ApiKeyListProps = {
  list: ApiKeyType[];
  onEdit: (apiKey: ApiKeyType) => void;
  onDelete: (apiKey: ApiKeyType) => void;
};

export const ApiKeyList = ({ list, onEdit, onDelete }: ApiKeyListProps) => {
  return (
    <>
      {list.map((item) => {
        const { id, name, is_expired, date_expired, ui_created_by, date_created } = item;
        const formattedCreateDate = formatDate(date_created);
        const formattedExpirationDate = formatDate(date_expired);
        const status = is_expired ? API_KEY_STATUS_TYPE.EXPIRED : API_KEY_STATUS_TYPE.ACTIVE;

        return (
          <Card key={id} title={name} header={name} meta={<ApiKeyStatus status={status} />}>
            <CardContent name='API Key ID' ratio={2}>
              {id}
            </CardContent>
            <CardContent name='Date Created'>{formattedCreateDate}</CardContent>
            <CardContent name='Expiration Date'>{formattedExpirationDate}</CardContent>
            <CardContent name='Created by'>{ui_created_by}</CardContent>
            <Box display='flex' mobile={{ justifyContent: 'end' }}>
              <PopoverMenuActions onEdit={() => onEdit(item)} onDelete={() => onDelete(item)} />
            </Box>
          </Card>
        );
      })}
    </>
  );
};
